import { createSelector, createSlice } from '@reduxjs/toolkit';
import { initApp } from './initApp';

interface State {
  status: 'idle' | 'loading' | 'success' | 'failed';
  error: string | any | null;
}

const initialState: State = {
  status: 'idle',
  error: null,
};

export const appInitSlice = createSlice({
  name: 'appInit',
  initialState,
  selectors: {
    selectAppInitStatus: createSelector([(state: State) => state], appInit => {
      return {
        isLoading: appInit.status === 'loading' || appInit.status === 'idle',
        isError: appInit.status === 'failed',
        isSuccess: appInit.status === 'success',
        error: appInit.error,
      };
    }),
  },
  reducers: {
    resetInitStatus: state => {
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(initApp.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(initApp.fulfilled, state => {
        state.status = 'success';
      })
      .addCase(initApp.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Unknown error';
      });
  },
});

export const { resetInitStatus } = appInitSlice.actions;
export const { selectAppInitStatus } = appInitSlice.selectors;
